module.exports = __webpack_public_path__ + "img/logo2.534c8c31.png";